import * as React from 'react';

const SvgSms = (props) => (
  <svg
    width={56}
    height={56}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M39.668 8.167H16.335c-7 0-11.667 3.5-11.667 11.666v16.334c0 8.166 4.667 11.666 11.667 11.666h23.333c7 0 11.667-3.5 11.667-11.666V19.833c0-8.166-4.667-11.666-11.667-11.666Zm1.097 14.21L33.46 28.21c-1.54 1.237-3.5 1.843-5.46 1.843s-3.943-.606-5.46-1.843l-7.303-5.833a1.795 1.795 0 0 1-.28-2.474c.607-.746 1.703-.886 2.45-.28l7.303 5.834c1.774 1.423 4.784 1.423 6.557 0l7.303-5.834c.747-.606 1.867-.49 2.45.28a1.77 1.77 0 0 1-.256 2.474Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgSms;
